import { GridFields } from 'components';
import { getYesOrNoOptions, isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';
import {
  Field,
  useFormContext,
  maxLengthTextField,
} from 'modules/client/legal/forms/companyGlobalFinancialMonitoringForm';

export interface FormContentProps {}

export const FormContent = () => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  return (
    <GridFields>
      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t(
          'client.legal.companyGlobalFinancialMonitoring.isSubjectToRegulation.label'
        )}
        name="globalFinancialMonitoring.isSubjectToRegulation"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.selectPlaceholder')}
        variant="select"
      />
      {isYes(values.globalFinancialMonitoring.isSubjectToRegulation) && (
        <>
          <Field.Text
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.supervisoryAuthorityNameAndLocation.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.supervisoryAuthorityNameAndLocation"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.supervisoryAuthorityNameAndLocation.placeholder'
            )}
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.mandatoryAmlRegulation.hasMandatoryAmlRegulations.label'
            )}
            name="globalFinancialMonitoring.mandatoryAmlRegulation.hasMandatoryAmlRegulations"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.mandatoryAmlRegulation
              ?.hasMandatoryAmlRegulations
          ) && (
            <>
              <Field.Text
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.mandatoryAmlRegulation.regulationDetails.label'
                )}
                maxLength={maxLengthTextField}
                name="globalFinancialMonitoring.mandatoryAmlRegulation.regulationDetails"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.mandatoryAmlRegulation.regulationDetails.placeholder'
                )}
              />
              <Field.Text
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.mandatoryAmlRegulation.authorizedBodyName.label'
                )}
                maxLength={maxLengthTextField}
                name="globalFinancialMonitoring.mandatoryAmlRegulation.authorizedBodyName"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.mandatoryAmlRegulation.authorizedBodyName.placeholder'
                )}
              />
            </>
          )}

          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.lastAmlAuditResult.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.lastAmlAuditResult"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.lastAmlAuditResult.placeholder'
            )}
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.investigationsOrSanctions.hadInvestigationsOrSanctions.label'
            )}
            name="globalFinancialMonitoring.investigationsOrSanctions.hadInvestigationsOrSanctions"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.investigationsOrSanctions
              ?.hadInvestigationsOrSanctions
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.investigationsOrSanctions.amlDecisionDateAndAuthorityInfo.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.hasInternalAmlDocuments.label'
            )}
            name="globalFinancialMonitoring.internalAmlDocuments.hasInternalAmlDocuments"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.internalAmlDocuments
              ?.hasInternalAmlDocuments
          ) && (
            <>
              <Field.DatePicker
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.adoptionDate.label'
                )}
                name="globalFinancialMonitoring.internalAmlDocuments.adoptionDate"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.adoptionDate.placeholder'
                )}
              />
              <Field.DatePicker
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.lastUpdateDate.label'
                )}
                name="globalFinancialMonitoring.internalAmlDocuments.lastUpdateDate"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.lastUpdateDate.placeholder'
                )}
              />
              <Field.Autocomplete
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.hasEffectivenessAssessmentProcedures.label'
                )}
                name="globalFinancialMonitoring.internalAmlDocuments.hasEffectivenessAssessmentProcedures"
                optionLabelKey="label"
                options={getYesOrNoOptions(t)}
                optionValueKey="value"
                placeholder={t('common.selectPlaceholder')}
                variant="select"
              />

              {isYes(
                values.globalFinancialMonitoring.internalAmlDocuments
                  ?.hasEffectivenessAssessmentProcedures
              ) && (
                <Field.Text
                  fullWidth
                  showRequiredMark
                  label={t(
                    'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.lastEffectivenessCheckInfo.label'
                  )}
                  maxLength={maxLengthTextField}
                  name="globalFinancialMonitoring.internalAmlDocuments.lastEffectivenessCheckInfo"
                  placeholder={t(
                    'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.lastEffectivenessCheckInfo.placeholder'
                  )}
                />
              )}
              <Field.Autocomplete
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.internalAmlDocuments.appliesToForeignAffiliates.label'
                )}
                name="globalFinancialMonitoring.internalAmlDocuments.appliesToForeignAffiliates"
                optionLabelKey="label"
                options={getYesOrNoOptions(t)}
                optionValueKey="value"
                placeholder={t('common.selectPlaceholder')}
                variant="select"
              />
            </>
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.departmentsResponsibleForAmlFunctions.hasDepartmentsResponsibleForAmlFunctions.label'
            )}
            name="globalFinancialMonitoring.departmentsResponsibleForAmlFunctions.hasDepartmentsResponsibleForAmlFunctions"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring
              .departmentsResponsibleForAmlFunctions
              ?.hasDepartmentsResponsibleForAmlFunctions
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.departmentsResponsibleForAmlFunctions.amlFunctionDepartmentsNames.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.hasResponsibleAmlManager.label'
            )}
            name="globalFinancialMonitoring.responsibleAmlManager.hasResponsibleAmlManager"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.responsibleAmlManager
              ?.hasResponsibleAmlManager
          ) && (
            <>
              <Field.Text
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.fullName.label'
                )}
                maxLength={maxLengthTextField}
                name="globalFinancialMonitoring.responsibleAmlManager.fullName"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.fullName.placeholder'
                )}
              />
              <Field.Text
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.position.label'
                )}
                maxLength={maxLengthTextField}
                name="globalFinancialMonitoring.responsibleAmlManager.position"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.position.placeholder'
                )}
              />
              <Field.Text
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.email.label'
                )}
                name="globalFinancialMonitoring.responsibleAmlManager.email"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.email.placeholder'
                )}
                type="email"
              />
              <Field.Phone
                fullWidth
                showRequiredMark
                label={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.phoneNumber.label'
                )}
                maxLength={22}
                name="globalFinancialMonitoring.responsibleAmlManager.phoneNumber"
                placeholder={t(
                  'client.legal.companyGlobalFinancialMonitoring.responsibleAmlManager.phoneNumber.placeholder'
                )}
                type="phone"
              />
            </>
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasRiskManagementProcedures.label'
            )}
            name="globalFinancialMonitoring.hasRiskManagementProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasSourceOfFundsProcedures.label'
            )}
            name="globalFinancialMonitoring.hasSourceOfFundsProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasRelationshipsWithPEPProcedures.label'
            )}
            name="globalFinancialMonitoring.hasRelationshipsWithPEPProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasAnonymousAccounts.label'
            )}
            name="globalFinancialMonitoring.hasAnonymousAccounts"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasAnonymousAccountPreventionProcedures.label'
            )}
            name="globalFinancialMonitoring.hasAnonymousAccountPreventionProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasTransactionMonitoringProcedures.label'
            )}
            name="globalFinancialMonitoring.hasTransactionMonitoringProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasAssetFreezingProcedures.label'
            )}
            name="globalFinancialMonitoring.hasAssetFreezingProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasAMLTrainingProcedures.label'
            )}
            name="globalFinancialMonitoring.hasAMLTrainingProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(values.globalFinancialMonitoring.hasAMLTrainingProcedures) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.amlTrainingDetails.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.amlTrainingDetails"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.amlTrainingDetails.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasBranchesInNonFATFCountries.label'
            )}
            name="globalFinancialMonitoring.hasBranchesInNonFATFCountries"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.hasBranchesInNonFATFCountries
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.nonFATFBranchesNamesAndLocations.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.nonFATFBranchesNamesAndLocations"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.nonFATFBranchesNamesAndLocations.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasCorrespondentsInNonFATFCountries.label'
            )}
            name="globalFinancialMonitoring.hasCorrespondentsInNonFATFCountries"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.hasCorrespondentsInNonFATFCountries
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.nonFATFCorrespondentsNames.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.nonFATFCorrespondentsNames"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.nonFATFCorrespondentsNames.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasCorrespondentsInOffshoreZones.label'
            )}
            name="globalFinancialMonitoring.hasCorrespondentsInOffshoreZones"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.hasCorrespondentsInOffshoreZones
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.offshoreCorrespondentsNames.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.offshoreCorrespondentsNames"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.offshoreCorrespondentsNames.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasShellBankRelationships.label'
            )}
            name="globalFinancialMonitoring.hasShellBankRelationships"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          {isYes(
            values.globalFinancialMonitoring.hasShellBankRelationships
          ) && (
            <Field.Text
              fullWidth
              showRequiredMark
              label={t(
                'client.legal.companyGlobalFinancialMonitoring.shellBanksNames.label'
              )}
              maxLength={maxLengthTextField}
              name="globalFinancialMonitoring.shellBanksNames"
              placeholder={t(
                'client.legal.companyGlobalFinancialMonitoring.shellBanksNames.placeholder'
              )}
            />
          )}

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasShellBankPreventionProcedures.label'
            )}
            name="globalFinancialMonitoring.hasShellBankPreventionProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasCDDRequestComplianceProcedures.label'
            )}
            name="globalFinancialMonitoring.hasCDDRequestComplianceProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.creditRating.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.creditRating"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.creditRating.placeholder'
            )}
          />
          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.subsidiariesNamesAndLocations.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.subsidiariesNamesAndLocations"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.subsidiariesNamesAndLocations.placeholder'
            )}
          />

          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.keyPartnersNames.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.keyPartnersNames"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.keyPartnersNames.placeholder'
            )}
          />

          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.foreignBranchesNamesAndLocations.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.foreignBranchesNamesAndLocations"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.foreignBranchesNamesAndLocations.placeholder'
            )}
          />

          <Field.Text
            fullWidth
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.financialGroupInfo.label'
            )}
            maxLength={maxLengthTextField}
            name="globalFinancialMonitoring.financialGroupInfo"
            placeholder={t(
              'client.legal.companyGlobalFinancialMonitoring.financialGroupInfo.placeholder'
            )}
          />
          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasSanctionPolicyDocuments.label'
            )}
            name="globalFinancialMonitoring.hasSanctionPolicyDocuments"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.hasSanctionsMonitoringProcedures.label'
            )}
            name="globalFinancialMonitoring.hasSanctionsMonitoringProcedures"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.isUnderSanctionsOrControlledBySanctionedEntity.label'
            )}
            name="globalFinancialMonitoring.isUnderSanctionsOrControlledBySanctionedEntity"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.isListedInSanctionLists.label'
            )}
            name="globalFinancialMonitoring.isListedInSanctionLists"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />

          <Field.Autocomplete
            fullWidth
            showRequiredMark
            label={t(
              'client.legal.companyGlobalFinancialMonitoring.isLinkedToSanctionedEntities.label'
            )}
            name="globalFinancialMonitoring.isLinkedToSanctionedEntities"
            optionLabelKey="label"
            options={getYesOrNoOptions(t)}
            optionValueKey="value"
            placeholder={t('common.selectPlaceholder')}
            variant="select"
          />
        </>
      )}
    </GridFields>
  );
};
